export const AUDIO_EXTENSIONS = ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'oga', 'flac', 'opus', 'webm', 'wma', 'aiff', 'aif'];

export function getExtension(name: string): string {
    const parts = name.split('.');
    return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
}

export function stripExtension(name: string): string {
    const idx = name.lastIndexOf('.');
    return idx > 0 ? name.slice(0, idx) : name;
}

export function isAudioFile(file: File): boolean {
    if (file.type && file.type.startsWith('audio/')) return true;
    return AUDIO_EXTENSIONS.includes(getExtension(file.name));
}

export function formatDuration(seconds?: number | null): string {
    if (!seconds || isNaN(seconds)) return '0:00';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${String(s).padStart(2, '0')}`;
}
